var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMucLogoV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "aria-labelledby": titleId,
    role: "img",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    x: "0px",
    y: "0px",
    viewBox: "0 0 499.6 146.6",
    style: {
      enableBackground: "new 0 0 499.6 146.6"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "muc-logo-wide"
  }, "My Utility Cabinet - Invoice Management Service Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "muc-logo-wide"
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FAA31A;}\n\t.st1{fill:#9B9B9B;}\n\t.st2{fill:#0B1F31;}\n\t.st3{fill:#29343F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0.1,35.7 0.1,64.1 63.9,28.7 127.8,64.1 127.8,35.9 63.9,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "32.2,54.1 64,36.7 95.2,54.1 64,72.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0.1,71.8 0.1,108.8 24.7,95.6 24.7,58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "127.8,71.9 127.8,109 102.7,95.3 102.7,58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "63.9,109.4 95.1,91.9 95.1,54.2 63.9,72.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "63.9,118.5 63.9,146.6 127.9,109.2 102.6,95.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "24.8,95.7 63.9,118.5 63.9,146.6 0,109  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "32,53.9 32,91.7 63.9,109.7 63.9,72.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.3,116.2h13.2l6.7-82.4h-13.5V22.3h29.9l27.1,64.3c1.6,4.3,2.4,7.6,2.4,7.6h0.3c0,0,0.7-3.3,2.4-7.6 l27.1-64.3h29.9v11.5h-13.5l6.7,82.4h13.2v11.7h-40.7v-11.7h12.7l-4.8-63.1c-0.1-3.3,0.4-8.7,0.4-8.7h-0.4c0,0-1.2,5.1-2.4,8.1 L211.8,108h-13.2l-24.2-55.5c-1.2-3-2.4-8.1-2.4-8.1h-0.4c0,0,0.6,5.4,0.4,8.7l-4.8,63.1h12.7v11.7h-40.7V116.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.1,33.9h-13.3V22.3h41.6v11.5h-13.3v54.6c0,6.9,1.3,12.9,4,17.2c4.3,6.9,12.6,10.8,22.7,10.8 c10,0,18.4-3.9,22.7-11.1c2.5-4.3,4-10.2,4-17V33.9h-13.3V22.3h41.4v11.5h-13.2v54.7c0,10-2.7,19.1-7.3,25.7 c-7.2,10.2-20,15.4-34.4,15.4c-14.9,0-27.5-5.7-34.7-15.4c-4.9-6.7-7-15.5-7-25.7V33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443.5,20.5c12.7,0,40.2,4.6,40.2,20.9v12.9h-13.9v-8.2c0-9.3-16-12.7-25.7-12.7c-22.6,0-39.2,16.6-39.2,40.5 c0,25,17,42.8,40.1,42.8c7.5,0,26.3-2.7,26.3-12.4V96h13.9v12.9c0,15.5-26.5,20.8-41.1,20.8c-31.7,0-54.6-24.4-54.6-55.2 C389.5,43.6,413,20.5,443.5,20.5z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 278.1,
    y: 116,
    className: "st0",
    width: 11.7,
    height: 11.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.9,
    y: 116,
    className: "st0",
    width: 11.7,
    height: 11.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.8,
    y: 116,
    className: "st0",
    width: 11.7,
    height: 11.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMucLogoV2);
export default __webpack_public_path__ + "static/media/muc-logo-v2.21544ca8.svg";
export { ForwardRef as ReactComponent };